import './CtaButtons.scss';

import { cloneElement, ReactElement } from 'react';

import Button from '../Button';
import { ButtonProps } from '../Button/Button';

interface Props {
  PrimaryCta?: ReactElement<ButtonProps, typeof Button>;
  SecondaryCta?: ReactElement<ButtonProps, typeof Button>;
}

const className = 'c-CtaButtons';

export const CtaButtons = ({ PrimaryCta, SecondaryCta }: Props) => {
  const hasCTAs = PrimaryCta || SecondaryCta;
  if (!hasCTAs) {
    return null;
  }

  return (
    <div className={className}>
      {PrimaryCta ? cloneElement(PrimaryCta, { mobileFluid: true }) : null}
      {SecondaryCta ? cloneElement(SecondaryCta, { mobileFluid: true }) : null}
    </div>
  );
};
